import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import NavigationItem from "./NavigationItem";
import images from "../../../images";
import { clearAllFormData } from "./../../../redux/featuresSlice/commonSlice";
import { clearAllFormDataSegmentation } from "../../../redux/featuresSlice/segmantation";

const NavigationBarConsumer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Define navItems with useMemo for stability
  const navItems = useMemo(
    () => [
      {
        label: "Home",
        path: "/",
        icon: images.HomeIcon,
        activeIcon: images.HomeActiveIcon,
      },
      {
        label: "Quests",
        path: "/quest",
        icon: images.QuestIcon,
        activeIcon: images.QuestActiveIcon,
      },
      {
        label: "Performance",
        path: "/performan",
        icon: images.PerformanceIcon,
        activeIcon: images.PerformanceIconActive,
      },
      {
        label: "Profile",
        path: "/profile",
        icon: images.ProfileIcon,
        activeIcon: images.ProfileActiveIcon,
      },
    ],
    []
  );

  // Memoize getActiveTab to stabilize it
  const getActiveTab = useCallback(() => {
    const index = navItems.findIndex((item) =>
      item.path === "/"
        ? location.pathname === "/"
        : location.pathname.includes(item.path)
    );
    return index !== -1 ? index : 0; // Default to 0 (Home) if no match
  }, [navItems, location.pathname]);

  const [activeTab, setActiveTab] = useState(getActiveTab());

  // Update activeTab when location.pathname changes
  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [getActiveTab]);

  // Handle navigation item click
  const handleItemClick = (index, path) => {
    if (activeTab !== index) {
      setActiveTab(index);
      navigate(path);
      // Clear form data only when navigating away from specific routes
      if (
        location.pathname.includes("/ondemand") ||
        location.pathname.includes("/segment")
      ) {
        dispatch(clearAllFormData());
        dispatch(clearAllFormDataSegmentation());
      }
    }
  };

  return (
    <nav
      className="w-full bg-white shadow-md max-w-[480px] mx-auto"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex justify-center items-end px-3 pt-2.5 pb-6 w-full text-xs leading-none whitespace-nowrap text-neutral-500">
        {navItems.map((item, index) => (
          <NavigationItem
            key={item.path}
            {...item}
            isActive={activeTab === index}
            onClick={() => handleItemClick(index, item.path)}
            aria-current={activeTab === index ? "page" : undefined}
          />
        ))}
      </div>
    </nav>
  );
};

export default NavigationBarConsumer;
